<template>
    <div class="boxbranco listagem-tabela-container mt-2">

        <b-alert :show="listagem.txOcupacao.length < 1 ? true : false" variant="danger">Nenhum dado encontrado</b-alert>

         <b-alert :show="listagem.txOcupacao.length > 0 ? true : false" variant="warning">Total da Taxa de Ocupação:<strong> {{txOcupacaoTotal()}}%</strong></b-alert>

        <div class="row">
            <div class="form-group col-md-8">
                <span>Mostrar </span>
                <select v-model="porPagina">
                   <option v-for="qtd in qtdItens" :key="qtd" :value="qtd">{{qtd}}</option>
                </select>
                <span> registros por página</span>
            </div>

            <div class="form-group col-md-4">
                <div class="input-group">
                    <input type="text" class="form-control" placeholder="Filtrar os resultados" v-model="filtro">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" :disabled="!filtro" @click="filtro = ''">Limpar</button>
                    </div>
                </div>
            </div>
        </div>

        <b-table
            :bordered="true"
            responsive
            hover
            thead-class="tcabecario"
            :items="listagem.txOcupacao"
            :fields="colunas"
            :per-page="porPagina"
            :filter="filtro"
            @filtered="onFiltered"
            :current-page="paginaAtual"
        >
            <template slot="ocupacao" slot-scope="row">
                <span>{{txOcupacao(row.item)}}%</span>
            </template>

        </b-table>

        <b-row>
            <b-col md="6" class="my-1">
                <b-pagination :total-rows="totalLinhas" :per-page="porPagina" v-model="paginaAtual" class="my-0" />
            </b-col>
        </b-row>

        <b-button v-if="listagem.txOcupacao.length > 0" variant="success" size="sm" class="mt-4" @click="gerarExcel()">Gerar Excel <i class="fa fa-file-excel-o" aria-hidden="true"></i></b-button>

    </div>
</template>

<script>
import { geraExcel } from '../../../shared/helpers/excel'

export default {
    props: {
        unidade: {
            type: String,
            default: ''
        },
        esfera: {
            type: String,
            default: ''
        }
    },
    computed: {
        taxa () {
            return this.$store.getters['relatorios/getMeianoite']
        },
        listagem () {
            if (this.esfera == '') return this.taxa
            else {
                let a = { ...this.taxa }
                let b = a.txOcupacao.filter(i => i.esferaUnidade == this.esfera)
                a.txOcupacao = b
                return a
            }
        },
        colunas () {
            let colunas = [
                { key: 'cnesUnidade', label: 'CNES', 'class': 'text-center' },
                { key: 'nomeUnidade', label: 'Nome da Unidade', 'class': 'text-center' },
                { key: 'quantidadeLeitoLivre', label: 'Livres', 'class': 'text-center' },
                { key: 'quantidadeLeitoOcupado', label: 'Ocupados', 'class': 'text-center' },
                { key: 'quantidadeLeitoCedido', label: 'Cedidos', 'class': 'text-center' },
                { key: 'quantidadeLeitoOperacional', label: 'Operacionais', 'class': 'text-center' },
                { key: 'quantidadeLeitoImpedido', label: 'Impedidos', 'class': 'text-center' },        
                { key: 'totalLeito', label: 'Total', 'class': 'text-center' },        
                { key: 'ocupacao', label: 'Taxa de Ocupação Operacional - Total', 'class': 'text-center' },        
            ]

            if (this.unidade == '') return colunas

            colunas.splice(2, 0, {key: 'nomeTipoClinico', sortable: true, label: 'Tipo Clínico', 'class': 'text-center' })

            return colunas
        }
    },
    data () {
        return {
            porPagina: 25,
            qtdItens: [ 25, 50, 100, 200 ],
            filtro: '',
            totalLinhas: '',
            paginaAtual: 1,
        }
    },
    watch: {
        listagem (value) {
            this.totalLinhas = value.txOcupacao.length;
        }
    },
    methods: {
        txOcupacao(item) {
            let conta = Math.round((item.quantidadeLeitoOcupado / item.quantidadeLeitoOperacional) * 100) 
            if (item.quantidadeLeitoOperacional == '0') return '0'
            else return conta
        },
        txOcupacaoTotal() {
            let oc = 0
            let op = 0
            this.listagem.txOcupacao.forEach(i => {
                oc = oc + parseInt(i.quantidadeLeitoOcupado)
                op = op + parseInt(i.quantidadeLeitoOperacional)
            })
            return  Math.round((oc / op) * 100)
        },
        gerarExcel() {
            let  campos = {
                "cnesUnidade": "CNES",
                "esferaUnidade": "Esfera",
                "nomeUnidade": "Nome da Unidade",
                "quantidadeLeitoCedido" : "Cedidos",
                "quantidadeLeitoImpedido": "Impedidos",
                "quantidadeLeitoLivre" : "Livres",
                "quantidadeLeitoOcupado": "Ocupados",
                "quantidadeLeitoOperacional": "Operacionais",
                "totalLeito": "Total"
            }

            geraExcel(campos, this.listagem.txOcupacao)
        }
    },
}
</script>

<style>
.table th,
.table td {
  font-size: 12px!important;
  padding: 8px!important;
  vertical-align: middle!important;
}
.tcabecario {
  background-color: #f3f2f2;
}
</style>
